import React from "react";
import ProductThumbs from "../product-thumbs";
import emptyContent from "./emptyContent.json";

const ProductThumbsList = (props) => {
  const productThumbsList = props["cms-component-product-thumbs"];
  const { cmsHandler, blockName, alias, CmsAddElement, CmsEditableGroupIcons } =
    props;
  //Logica de conservar el query por el proyecto de dispos
  let query = {};

  if (
    !productThumbsList ||
    !Array.isArray(productThumbsList) ||
    (productThumbsList.length === 0 && !process.env.NEXT_PUBLIC_ASTRO_MAKER)
  ) {
    return null;
  }

  function getQueryParams() {
    let queryParams = {};
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      for (const [key, value] of params.entries()) {
        queryParams[key] = value;
      }
    }
    return queryParams;
  }

  if (typeof window !== "undefined") {
    query = getQueryParams();
  }

  return (
    <>
      <section id={blockName || ""} className="product-thumbs-list container">
        {CmsAddElement && (
          <CmsAddElement
            addProps={{
              index: "start",
              contentId: blockName,
              itemIdDotNotation: `${blockName}.cms-component-product-thumbs`,
              layout: "vertical",
            }}
            cmsHandler={cmsHandler}
          />
        )}
        {productThumbsList.length === 0 ? (
          <ProductThumbs {...emptyContent} />
        ) : (
          productThumbsList.map((productThumbs, index) => (
            <div className="featured-carousel" key={`thumbs-list-${index}`}>
              <ProductThumbs
                {...productThumbs}
                query={query}
                cmsHandler={cmsHandler}
                blockName={blockName}
                listIndex={index}
                alias={alias}
                parentIndex={index}
                frontalListToDelete={productThumbsList}
                CmsAddElement={CmsAddElement}
                CmsEditableGroupIcons={CmsEditableGroupIcons}
              />
            </div>
          ))
        )}
        {CmsAddElement && (
          <CmsAddElement
            addProps={{
              index: "end",
              contentId: blockName,
              itemIdDotNotation: `${blockName}.cms-component-product-thumbs`,
              layout: "vertical",
            }}
            cmsHandler={cmsHandler}
          />
        )}
      </section>
      <style jsx>{`.product-thumbs-list {
  background-color: #ffffff;

  .featured-carousel {
    position: relative;
  }
}
`}</style>
    </>
  );
};

export default ProductThumbsList;
